import { render } from "./Island.vue?vue&type=template&id=3b96a8dc"
import script from "./Island.vue?vue&type=script&lang=js"
export * from "./Island.vue?vue&type=script&lang=js"

import "./Island.vue?vue&type=style&index=0&id=3b96a8dc&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__